import { ReactElement } from "react";
import { useAuth } from "../../context/AuthProvider";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

const Login = (): ReactElement => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#2a3042",
      }}
    >
      {isLoading && <CircularProgress sx={{ color: "#fff" }} />}
    </Box>
  );
};

export default Login;
